import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import Parallax from '../ui/Parallax'

export default function CTASection() {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-premium-950 via-gray-950 to-premium-950" />
      <Parallax speed={0.2} className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px]">
        <div className="w-full h-full rounded-full bg-gradient-to-br from-electric-blue/10 via-electric-purple/10 to-transparent blur-[120px]" />
      </Parallax>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block mb-4 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-electric-blue bg-electric-blue/10 rounded-full border border-electric-blue/20">
            Let's Collaborate
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-3xl mx-auto">
            Ready to Build Something{' '}
            <span className="bg-gradient-to-r from-electric-blue to-electric-purple bg-clip-text text-transparent">
              Extraordinary
            </span>
            ?
          </h2>
          <p className="mt-6 text-lg text-gray-400 max-w-xl mx-auto leading-relaxed">
            Let's turn your vision into a digital masterpiece. Get in touch for a
            free consultation and project estimate.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link
              to="/contact"
              className="px-8 py-3.5 text-base font-semibold text-white rounded-full bg-gradient-to-r from-electric-blue to-electric-purple hover:shadow-lg hover:shadow-electric-blue/25 transition-all duration-300 hover:scale-105"
            >
              Start Your Project
            </Link>
            <Link
              to="/portfolio"
              className="px-8 py-3.5 text-base font-semibold text-white rounded-full border border-white/10 hover:border-white/20 bg-white/5 hover:bg-white/10 transition-all duration-300"
            >
              See Our Work
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
